import { Component } from '@angular/core';
import { Service } from '@models/service/service';

@Component({
  selector: 'app-patient-chart-tab',
  templateUrl: './patient-chart-tab.component.html',
  styleUrls: ['./patient-chart-tab.component.less'],
})
export class PatientChartTabComponent {
  showOverview = true;
  service: Service;
  treatmentIsFromToday: boolean;

  constructor() {}
}
